import React, { Component } from 'react';
import FullPageLoader from '../../../common/fullPageLoader';

export default class ImageZoom extends Component {
    render() {
        const {image, productLoading} = this.props;

        if (productLoading ) {
            return (
                <FullPageLoader />
            )
        }

        return (
            <img src={`${image}`}  className="img-fluid image_zoom_cls-0" />
        );
    }
}